import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, output } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ToFormGroup } from '@scripts/utils/types';
import { WooNumberFormatter } from '@scripts/woo_components.module/directives/woo-number-formatter.directive';
import { BaseModalComponent } from '@src/shared/modal/base-modal/base-modal.component';
import { ModalLayoutComponent } from '@src/shared/modal/base-modal/modal-layout/modal-layout.component';

@Component({
  selector: 'app-stop-campaign-modal',
  imports: [ModalLayoutComponent, FormsModule, ReactiveFormsModule, WooNumberFormatter, CommonModule],
  templateUrl: './stop-campaign-modal.component.html',
  styleUrl: './stop-campaign-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StopCampaignModalComponent extends BaseModalComponent<{
  initialOrderValue: number;
}> {
  fb = inject(FormBuilder);
  initialOrderValue = computed(() => this.modaldata().initialOrderValue);
  submit = output<{ newOrderValue: number; comment: string }>();
  form: FormGroup<ToFormGroup<StopCampaignData>> = this.fb.group({
    newOrderValue: new FormControl(null, [Validators.required, () => this.validateOrderValue()]),
    comment: new FormControl('', [Validators.required, (cm) => this.validateComment(cm)]),
  });

  private validateOrderValue() {
    if (!this.form || !this.initialOrderValue() || !this.form.controls.newOrderValue.value) {
      return null;
    }

    const invalid = this.form.controls.newOrderValue.value > this.initialOrderValue();
    return invalid ? { invalidOrderValue: 'Nytt ordervärde får inte vara större än nuvarande ordervärde.' } : null;
  }

  private validateComment(comment: AbstractControl) {
    if (!this.form || !comment.value) {
      return null;
    }

    const invalid = comment.value.trim().length === 0;
    return invalid ? { invalidComment: 'Måste ha ett stoppmeddelande' } : null;
  }
}

type StopCampaignData = {
  newOrderValue: number;
  comment: string;
};
